import * as React from 'react';
export const citynationalSvg = React.forwardRef(function citynationalSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#1B70C4',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'm18.4 8.25-.18 2.95-3.88-1.49-.71-.28-1.57-.62 1.5-.61-.21-3.88-2.97 1.29 2.8 20.01 1.29-.82-.06-1.2 3 1.15-.2 2.8 1.38-1.13 3-19.86-3.19 1.69zm-.37 6.26-3.31-1.26-.9-.35-1.32-.52 1.25-.54-.1-1.84 4.57 1.74-.19 2.77zm-.19 2.98-2.96-1.16-.91-.33-1.31-.51 1.25-.52-.1-1.54 4.16 1.6-.13 2.46zM17.7 20l-2.66-1.02-.9-.36-1.16-.44 1.1-.46-.07-1.2 3.81 1.46L17.7 20zm-.16 2.31-2.37-.92-.94-.36-1.1-.44 1.07-.43-.06-1.08 3.53 1.36-.13 1.87zm-.12 2.39v-.3l-1.94-.75-1.1-.41-1.06-.41 1-.41-.06-.93 3.25 1.26-.1 1.95z',
      }),
    ),
  );
});
citynationalSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var citynational = {
  category: 'brand',
  colorable: false,
  name: 'citynational',
  svg: citynationalSvg,
};
